export const GetFlows = (builder) => ({
    getFlows: builder.mutation({
        query: () => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: process.env.REACT_APP_CHATBOT_API_PORT + '/chat/getListOfFlow', 
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            }
        },
    }),
});